import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';


const bodyStyles = makeStyles({
    root:{
        backgroundColor: '#ffffff',
        color: '#000000',
        position: 'absolute',
        left: 0,
        top: 60,
        right:0,
        bottom:0
    }
});

const headlessBodyStyles = makeStyles({
    root: {
        backgroundColor: '#ffffff',
        color: '#000000',
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    }
});


export function Body(props){
    const classes = bodyStyles()
    return (
        <Box className={classes.root} p={0} m={0}>
            {props.children}
        </Box>
    )
}

export function HeadlessBody(props) {
    const classes = headlessBodyStyles()
    return (
        <Box className={classes.root} p={0} m={0}>
            {props.children}
        </Box>
    )
}